import axios from 'axios';

export default {
  namespaced: true,
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    async retrieveVersions(context, data) {
      try {
        const config = { withCredentials: true };
        if (data && data.sharedToken) config.headers = { Authorization: data.sharedToken };
        const items = await axios.get(`/autodesk/data-management/data-management/projects/${data.projectId}/items/${data.itemId}`, config);
        return items.data;
      } catch (error) {
        throw error;
      }
    },
  },
};
